import React, { Component, PropTypes } from 'react';
import lodash from 'lodash';
import { Table, Well, Button, Modal, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/users';
import { nations } from '../../constants/values';
import formValidation from '../../utils/formValidation';
import { onInputChange, getEnumLong } from '../../utils/helpers';
import { Input } from '../../components/inputs';

const nationsWithoutAdmin = nations.filter(n => n.value !== 'ADMIN');

const initialUserData = {
  nation: '',
  isAdmin: false,
};

const mapStateToProps = state => ({
  token: state.auth.token,
  users: state.users.users,
  isPushingData: state.users.isPushingData,
  isResettingPassword: state.users.isResettingPassword,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

class UserManagement extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    isPushingData: PropTypes.bool.isRequired,
    isResettingPassword: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      formErrors: [],
      showCreateUserModal: false,
      showPasswordModal: false,
      showConfirmModal: false,
      userData: lodash.cloneDeep(initialUserData),
      user: {},
      userId: undefined,
    };

    this.onInputChange = onInputChange().bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    const { token, actions } = this.props;

    actions.fetchUsers(token);
  }

  openCreateUserModal = () => {
    this.setState({
      showCreateUserModal: true,
    });
  };

  closeCreateUserModal = () => {
    this.setState({
      showCreateUserModal: false,
      userData: lodash.cloneDeep(initialUserData),
      formErrors: [],
    });
  };

  openPasswordModal = user => {
    this.setState({
      showPasswordModal: true,
      user,
    });
  };

  closePasswordModal = () => {
    this.setState({
      showPasswordModal: false,
      user: {},
    });
  };

  openConfirmModal = userId => {
    this.setState({
      showConfirmModal: true,
      userId,
    });
  };

  closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      userId: undefined,
    });
  };

  submitForm = () => {
    const { token, actions } = this.props;
    const { userData } = this.state;

    formValidation({
      userData,
    }).then(formErrors => {
      this.setState({ formErrors });

      if (!!formErrors.length) {
        return;
      }

      actions
        .createUser(token, userData)
        .then(user => {
          this.closeCreateUserModal();
          this.openPasswordModal(user);
        })
        .catch(() => {
          this.closeCreateUserModal();
        });
    });
  };

  resetPassword = () => {
    const { token, actions } = this.props;
    const { userId } = this.state;

    actions
      .resetPassword(token, userId)
      .then(user => {
        this.closeConfirmModal();
        this.openPasswordModal(user);
      })
      .catch(() => {
        this.closeConfirmModal();
      });
  };

  renderCreateUserModal() {
    const { isPushingData, users } = this.props;
    const { showCreateUserModal, formErrors } = this.state;

    let notCreatedNations = nationsWithoutAdmin;

    if (showCreateUserModal) {
      notCreatedNations = nationsWithoutAdmin.filter(n => !users.find(u => u.nation === n.value));
    }

    return (
      <Modal show={showCreateUserModal} onHide={this.closeCreateUserModal}>
        <Modal.Header closeButton>
          <Modal.Title>Create Federation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <Input
              type="select"
              onChange={this.onInputChange('userData.nation')}
              defaultValue=""
              errors={formErrors}
              name="nation"
              label="Nation"
            >
              <option disabled value="" />
              {notCreatedNations.map(nation => (
                <option key={nation.value} value={nation.value}>
                  {nation.name}
                </option>
              ))}
            </Input>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.submitForm}
            disabled={isPushingData}
            bsStyle="primary"
          >
            Submit
          </Button>
          <Button type="button" onClick={this.closeCreateUserModal} disabled={isPushingData}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderPasswordModal() {
    const { showPasswordModal, user } = this.state;

    return (
      <Modal show={showPasswordModal} onHide={this.closePasswordModal}>
        <Modal.Header closeButton>
          <Modal.Title>Federation has been created successfuly</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <strong>Nation:</strong> {user.nation}
          </p>
          <p>
            <strong>Password:</strong> {user.password}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" onClick={this.closePasswordModal} bsStyle="primary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderConfirmModal() {
    const { showConfirmModal } = this.state;
    const { isResettingPassword } = this.props;

    return (
      <Modal show={showConfirmModal} onHide={this.closeConfirmModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to reset the password for this federation?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.resetPassword}
            disabled={isResettingPassword}
            bsStyle="primary"
          >
            Yes
          </Button>
          <Button type="button" onClick={this.closeConfirmModal} disabled={isResettingPassword}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { users } = this.props;

    return (
      <div>
        <h3 style={{ marginBottom: 0 }}>Federations Management</h3>

        {this.renderCreateUserModal()}
        {this.renderPasswordModal()}
        {this.renderConfirmModal()}

        <Row>
          <Col xs={2} xsOffset={10}>
            <Button
              type="button"
              bsStyle="primary"
              bsSize="sm"
              onClick={this.openCreateUserModal}
              block
              style={{ marginBottom: 10 }}
            >
              <i className="fa fa-plus" /> Add Federation
            </Button>
          </Col>
        </Row>

        {!!users.length && (
          <Table striped bordered condensed hover responsive>
            <thead>
              <tr>
                <th>Nation</th>
                <th>Name</th>
                <th>E-Mail</th>
                <th className="action">Is Admin</th>
                <th className="action">Reset Password</th>
              </tr>
            </thead>
            <tbody>
              {users &&
                users.map(user => (
                  <tr key={`u_${user.id}`}>
                    <td>
                      <Link to={`/admin/entries/${user.nation}`}>
                        {getEnumLong('nations', user.nation)}
                      </Link>
                    </td>
                    <td>{user.name}</td>
                    <td>
                      <a href={`mailto:${user.email}`}>{user.email}</a>
                    </td>
                    <td className="action">{user.isAdmin ? 'Yes' : '-'}</td>
                    <td className="action">
                      <Button
                        type="button"
                        bsStyle="warning"
                        bsSize="xs"
                        onClick={this.openConfirmModal.bind(this, user.id)}
                      >
                        <i className="fa fa-repeat fa-fw" />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

        {!users.length && <Well>You have not created any federation yet</Well>}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement)


// WEBPACK FOOTER //
// ./src/components/user/UserManagement.js